import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { UIRouterModule } from '@uirouter/angular';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComponentsModule } from '../components/components.module';
import { ExpandablePanelComponent } from '../components/expandable-panel/expandable-panel.component';
import { NotificationAlertComponent } from '../components/notification-alert/notification-alert.component';
import { QuantityComponent } from '../components/quantity/quantity.component';
import { RvBadgeComponent } from '../components/rv-badge/rv-badge.component';
import { SkeletonComponent } from '../components/skeleton/skeleton.component';
import { SharedModule } from '../shared/shared.module';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { BillingAddressComponent } from './components/billing-address/billing-address.component';
import { ChangePlanComponent } from './components/change-plan/change-plan.component';
import { CheckoutSuccessComponent } from './components/checkout-success/checkout-success.component';
import { CreditCardFormComponent } from './components/credit-card-form/credit-card-form.component';
import { PaymentMethodsFormComponent } from './components/payment-methods-form/payment-methods-form.component';
import { PaymentMethodsComponent } from './components/payment-methods/payment-methods.component';
import { PendingChangeAlertComponent } from './components/pending-change-alert/pending-change-alert.component';
import { PlanTierPickerComponent } from './components/plan-tier-picker/plan-tier-picker.component';
import { PurchaseAddOnComponent } from './components/purchase-add-on/purchase-add-on.component';
import { PurchaseAiCreditsComponent } from './components/purchase-ai-credits/purchase-ai-credits.component';
import { PurchaseFooterComponent } from './components/purchase-footer/purchase-footer.component';
import { PurchaseInteractiveLicenseComponent } from './components/purchase-interactive-license/purchase-interactive-license.component';
import { PurchaseSummaryComponent } from './components/purchase-summary/purchase-summary.component';
import { PurchaseComponent } from './components/purchase/purchase.component';
import { SelectPlanComponent } from './components/select-plan/select-plan.component';
import { TaxExemptionComponent } from './components/tax-exemption/tax-exemption.component';
import { UpdatePlanComponent } from './components/update-plan/update-plan.component';
import { UpdateSubscriptionSuccessComponent } from './components/update-subscription-success/update-subscription-success.component';
import { UpdateSubscriptionComponent } from './components/update-subscription/update-subscription.component';
import { ProvinceValidatorDirective } from './directives/province-validator.directive';
import { CardDescriptionPipe } from './pipes/card-description.pipe';
import { ViewportComponent } from './viewport/viewport.component';
import { ActionLinkDirective } from '../accessibility/directives/action-link/action-link.directive';

@NgModule({
  declarations: [
    CardDescriptionPipe,
    TaxExemptionComponent,
    PurchaseFooterComponent,
    PurchaseSummaryComponent,
    CheckoutSuccessComponent,
    AddressFormComponent,
    BillingAddressComponent,
    ProvinceValidatorDirective,
    PaymentMethodsComponent,
    PaymentMethodsFormComponent,
    CreditCardFormComponent,
    PurchaseComponent,
    UpdateSubscriptionComponent,
    UpdateSubscriptionSuccessComponent,
    ViewportComponent,
    PlanTierPickerComponent,
    SelectPlanComponent,
    UpdatePlanComponent,
    ChangePlanComponent,
    PendingChangeAlertComponent,
    PurchaseAddOnComponent,
  ],
  imports: [
    ActionLinkDirective,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UIRouterModule,
    ComponentsModule,
    SharedModule,
    PopoverModule,
    MatCheckboxModule,
    MatDividerModule,
    MatRadioModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    NotificationAlertComponent,
    ExpandablePanelComponent,
    QuantityComponent,
    RvBadgeComponent,
    SkeletonComponent,
    MatTooltipModule,
    PurchaseAiCreditsComponent,
    PurchaseInteractiveLicenseComponent,
  ],
  exports: [
    CardDescriptionPipe,
    TaxExemptionComponent,
    PurchaseFooterComponent,
    CreditCardFormComponent,
    PaymentMethodsFormComponent,
    PendingChangeAlertComponent,
    BillingAddressComponent,
    PaymentMethodsComponent,
    CheckoutSuccessComponent,
    PurchaseAddOnComponent,
  ],
})
export class PurchaseComponentsModule {}
